import Mention from '@/javascripts/components/Mention';

if (!window.Coorum) {
  window.Coorum = {};
}
window.Coorum.Mention = Mention;
